// app/javascript/channels/index.js
import consumer from "./consumer"

// すべてのチャンネルファイルを動的にインポート
const channels = import.meta.glob('./**/*_channel.js',{ eager: true })

// 各チャンネルモジュールを読み込み、初期化
Object.entries(channels).forEach(([path, moduleLoader]) => {
    moduleLoader().then(module => {
        // モジュールが正常に読み込まれたら処理を実行
        console.log(`Loaded channel: ${path}`)
    }).catch(error => {
        console.error(`Error loading channel ${path}:`, error)
    })
})

// グローバルに公開（必要な場合）
// window.cable = consumer
